import {
	STANDARD_TRIAL_DAYS_TO_DEACTIVATION,
	getDeactivationDate,
} from '@atlassian/auto-upgrade-not-a-trial';
import { AutoUpgradeAvoidDeactivationModal } from '@atlassian/auto-upgrade-not-a-trial/auto-upgrade-avoid-deactivation-modal-component';
import {
	getBillingLink,
	getRemoveUsersUrl,
} from '@post-office/components--commerce-email/ui/utils';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback, useEffect, useState } from 'react';

import { type Product, createRender } from './types';

export const render = createRender(({ envType, messageContext }) => {
	const [showModal, setShowModal] = useState(true);
	const { messageDismissed, messageViewed } = useMessageEvent();
	const { messageInstanceClicked, messageInstanceViewed } = useMessageInstanceEvent();

	useEffect(() => {
		void messageViewed();
		void messageInstanceViewed();
	}, [messageViewed, messageInstanceViewed]);

	const handleClose = useCallback(() => {
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'dismissButton',
				clickedElement: 'button',
				buttonType: 'secondary',
			},
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {
				type: 'autoUpgradeAvoidDeactivationModal',
			},
		});
		void messageDismissed();
		setShowModal(false);
	}, [messageDismissed, messageInstanceClicked]);

	const {
		transactionAccountId,
		invoiceGroupId,
		orgId,
		productName,
		exceedingUsageCount,
		trialEndDate,
	} = messageContext.entities;
	const { isPartner } = messageContext.facts;
	const addPaymentUrl = getBillingLink({
		isPartner,
		transactionAccountId,
		invoiceGroupId,
		envType,
	});
	const removeUsersUrl = getRemoveUsersUrl(envType, orgId);

	const deactivationDate = trialEndDate
		? getDeactivationDate(trialEndDate, STANDARD_TRIAL_DAYS_TO_DEACTIVATION)
		: undefined;

	return showModal ? (
		<AutoUpgradeAvoidDeactivationModal
			product={productName as Product}
			touchpointId="autoUpgradePopupModal"
			deactivationDate={deactivationDate}
			licensedUsers={exceedingUsageCount}
			addPaymentUrl={addPaymentUrl}
			removeUsersUrl={removeUsersUrl}
			onClose={handleClose}
		/>
	) : null;
});

export default render;
